var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 56C9 51.5817 12.5817 48 17 48C21.4183 48 25 51.5817 25 56V77.6H9V56Z",
    fill: "#7A9FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 41.6001C33 37.1818 36.5817 33.6001 41 33.6001C45.4183 33.6001 49 37.1818 49 41.6001V77.6001H33V41.6001Z",
    fill: "#4A67FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2 26.3999C56.2 21.9816 59.7817 18.3999 64.2 18.3999C68.6182 18.3999 72.2 21.9816 72.2 26.3999V77.5999H56.2V26.3999Z",
    fill: "#0000CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3999 75.2H78.5999",
    stroke: "#09090B",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3999 40.4C22.9999 34.4 46.1199 22.4 58.5999 8",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2054 14.7305L60.4166 5.71394L51.4001 6.50278",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.c6849407fdfc315f783fdb126f18d96b.svg";
export { ForwardRef as ReactComponent };